import React, { useState } from 'react'
import styles from "./style.module.css"
import { Button, Input } from '@chakra-ui/react'
import { useDispatch } from 'react-redux'
import { message } from 'antd'
import Select from 'react-select';
import { createNotificationData } from '../../../Redux/PushNotification/NotificationReducer'
import pushIcon from "../../../assets/for_this/pushIcon.svg"
import dateIcon from "../../../assets/dateIcon.png"
import timeIcon from "../../../assets/timeIcon.png"
import ReactDatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css';

const cityOptions = [
  { value: 'Berlin', label: 'Berlin' },
  { value: 'Paris', label: 'Paris' },
  { value: 'New York', label: 'New York' },
];
const initialState = {
  name: "dont know",
  "title": "",
  "body": "",
  "type": "PARTNER",
  "sendTo": "All",
  "releaseDate": "",
  "releaseTime": "",
  "partnerId": JSON.parse(localStorage.getItem("userId"))
}

const CreateNotification = ({ setCreate }) => {
  const dispatch = useDispatch()

  const [form, setForm] = useState(initialState)
  console.log('form:', form)
  const [selectedCities, setSelectedCities] = useState([]);
  const customStyles = {
    control: (provided) => ({
      ...provided,
      width: "100%",
      height: "75px", // Set the desired height for the entire select component
      borderRadius: "18px",
      alignItems: "center", // Center content vertically
      justifyContent: "center",
      display: "flex",
      border: "none",
      boxShadow: "none",
      backgroundColor: "#ecf1f4",
    }),
    menu: (provided) => ({
      ...provided,
      width: "100%",
      backgroundColor: "#ecf1f4",
      alignItems: "center",
      fontSize: "15px",
      // Center content vertically

      color: "black",
      zIndex: 2, // Ensure the menu appears above other elements
    }),
    option: (provided, state) => ({
      ...provided,
      minHeight: "60px", // Set the desired height for each option item
      display: "flex", // Use flex to vertically align content
      alignItems: "center", // Center content vertically
      backgroundColor: "#ecf1f4",
      color: "black",
      cursor: "pointer",
      fontSize: "15px",
      borderBottom: "1px solid white",
      textAlign: "center",
    }),
    indicatorSeparator: () => ({
      display: "none", // Hide the default arrow and line
    }),
  };

  // ...


  const handleCityChange = (selectedOptions) => {
    setSelectedCities(selectedOptions);
  };
  const addData = () => {
    if (!form.title) {
      message.error("Title is required")

    } else {
      if (!form.body) {
        message.error("Body is required")
      }
      else {
        if (!selectedCities.length) {
          message.error("cities is required")
        } else {
          if (!form.releaseDate) {
            message.error("Release Date is required")
          } else {
            if (!form.releaseTime) {
              message.error("Release Time is required")
            } else {


              dispatch(createNotificationData({ ...form, cities: selectedCities.value })).then(() => {
                setCreate(false)
                message.success("Notification created successfully")
              })


            }
          }
        }
      }
    }

  }

  return (
    <div className={styles.MainContainer}>

      <div className={styles.container1}>
        <span>
          All Notifications {'>'} <b style={{ opacity: "100%", color: "#131313" }}>Create New Notification</b>
        </span>
        <h1>
          Create New Notification
        </h1>

        <div className={styles.resetPassword}>
          <p>Title*</p>
          <Input placeholder='Title (max. 50 characters)' value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} maxLength={50} />
          <p>Body*</p>
          <Input placeholder='Add Body (max. 150 characters)' value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} maxLength={150} />

          <p>Only Received by users in the following city:</p>
          <Select
            isMulti
            styles={customStyles}
            options={cityOptions}
            value={selectedCities}
            onChange={handleCityChange}
          />
          <div className={styles.dateDiv}>
            <p>Release on:</p>
            <div className={styles.date}>
            <img
            src={dateIcon}
            style={{ paddingLeft: "1rem", cursor: "pointer" }}
            // onClick={toggleCalendar}
            ></img>
            <ReactDatePicker selected={form.releaseDate} onChange={(e) => setForm({ ...form, releaseDate: e })} placeholderText='Select date' />
            </div>

            <div className={styles.time}>
            <img
            src={timeIcon}
            style={{ paddingLeft: "1rem", cursor: "pointer" }}
            // onClick={toggleCalendar}
            ></img>
            <ReactDatePicker
              selected={form.releaseTime}
              onChange={(e) => setForm({ ...form, releaseTime: e })}
              showTimeSelect
              showTimeSelectOnly // Show time selection only, not the date
              timeIntervals={15} // Set the time interval in minutes (optional)
              dateFormat="h:mm aa" // Time-only format
               placeholderText="Select time"
            />
            </div>

          </div>
        </div>

      </div>
      <div className={styles.container2}>
        <div className={styles.btn}>
          <Button colorScheme='black' variant='outline' w="127px" onClick={() => setCreate(false)}>Cancel</Button>
          <Button bg="#333333" color="#fff" variant='solid' w="227px" onClick={addData}>Send for approval</Button>

        </div>
        <div className={styles.preview} >
          <p>Preview</p>
          <div className={styles.previewInner} >
            <span className={styles.spanIcon}>
              <img src={pushIcon} alt="" />
            </span>
            <h2>{form.title}</h2>
            <p>{form.body}</p>

          </div>



        </div>


      </div>
    </div>
  )
}

export default CreateNotification